export const devToken = {
  geoToken: "556802988204455841232x59245",
  mapToken:
    "pk.eyJ1IjoiYm9yYTAwMSIsImEiOiJja3pjNWU0MWwxYWVpMm5sYmdncWhlaG51In0.UQpwavBjEPi8G-jhAfQmiA",
  firebaseUrl:
    "https://react-placelist-default-rtdb.asia-southeast1.firebasedatabase.app/",
  REACT_APP_MAPBOX_ACCESS_TOKEN:
    "pk.eyJ1IjoiYm9yYTAwMSIsImEiOiJja3pjNWU0MWwxYWVpMm5sYmdncWhlaG51In0.UQpwavBjEPi8G-jhAfQmiA",
  REACT_APP_APIKEY: "AIzaSyDJuEBwSgfORdel4ZJ7q_emHSpl1qcAkZE",
  REACT_APP_AUTH_DOMAIN: "react-placelist.firebaseapp.com",
  REACT_APP_DATA_BASE_URL:
    "https://react-placelist-default-rtdb.asia-southeast1.firebasedatabase.app",
  REACT_APP_PROJECT_ID: "react-placelist",
  REACT_APP_STORAGE_BUCKET: "react-placelist.appspot.com",
  REACT_APP_MESSAGING_SENDER_ID: "120171297532",
  REACT_APP_APP_ID: "1:120171297532:web:8d4d5b780d367328a6b579",
};
